import { apiClient } from "services/api-client";

// Cloud Accounts
export const getScannerAccounts = async (slug) =>
  apiClient.get(`/cspm/cloud-accounts?companyKey=${slug}`);

export const createScannerAccount = async (data) =>
  apiClient.post(`/cspm/cloud-accounts`, data);

export const deleteScannerAccount = async (id, slug) =>
  apiClient.delete(`/cspm/cloud-accounts/${id}?companyKey=${slug}`);

export const getScannerAccountConnection = async (id, slug) =>
  apiClient.get(`/cspm/cloud-accounts/${id}/connection?companyKey=${slug}`);

export const importScannerAccount = async (data, slug) =>
  apiClient.post(`/cspm/cloud-accounts/import`, { ...data, companyKey: slug });

// Scans
export const getScannerScans = async (slug, page = 1, limit = 20) =>
  apiClient.get(`/cspm/scans?companyKey=${slug}&page=${page}&limit=${limit}`);

export const getScannerScan = async (id) =>
  apiClient.get(`/cspm/scans/${id}`);

export const getScanFindings = async (id, page = 1, severity, status) => {
  let url = `/cspm/scans/${id}/findings?page=${page}&limit=50`;
  if (severity && severity !== 'all') url += `&severity=${severity}`;
  if (status && status !== 'all') url += `&status=${status}`;
  return apiClient.get(url);
};

// Stats
export const getScannerStats = async (slug) =>
  apiClient.get(`/cspm/findings/stats?companyKey=${slug}`);

// Findings
export const getScannerFindings = async (slug, page = 1, severity, status, framework, limit = 50) => {
  let url = `/cspm/findings?companyKey=${slug}&page=${page}&limit=${limit}`;
  if (severity) url += `&severity=${severity}`;
  if (status) url += `&status=${status}`;
  if (framework) url += `&framework=${framework}`;
  return apiClient.get(url);
};

// Grouped findings — returns one entry per unique check, paginated by group
export const getScannerFindingGroups = async (slug, page = 1, severity, status, limit = 10) => {
  let url = `/cspm/findings/groups?companyKey=${slug}&page=${page}&limit=${limit}`;
  if (severity && severity !== 'all') url += `&severity=${severity}`;
  if (status && status !== 'all') url += `&status=${status}`;
  return apiClient.get(url);
};

// Resources for a specific check (used when expanding a group row)
export const getScannerFindingsByCheck = async (slug, checkId, severity, status) => {
  let url = `/cspm/findings?companyKey=${slug}&checkId=${encodeURIComponent(checkId)}&limit=100`;
  if (severity && severity !== 'all') url += `&severity=${severity}`;
  if (status && status !== 'all') url += `&status=${status}`;
  return apiClient.get(url);
};

// ThreatScore — Prowler-weighted compliance score (matches Prowler UI exactly)
export const getScannerThreatScore = async (slug) =>
  apiClient.get(`/cspm/findings/threatscore?companyKey=${encodeURIComponent(slug)}`);

// Compliance Watchlist — all frameworks sorted worst-first
export const getScannerCompliance = async (slug) =>
  apiClient.get(`/cspm/findings/compliance?companyKey=${encodeURIComponent(slug)}`);

// Service Watchlist — AWS services sorted by fail count
export const getScannerServiceWatchlist = async (slug) =>
  apiClient.get(`/cspm/findings/service-watchlist?companyKey=${encodeURIComponent(slug)}`);

// Region Map — per-region fail/pass counts for the threat map
export const getScannerRegionMap = async (slug) =>
  apiClient.get(`/cspm/findings/region-map?companyKey=${encodeURIComponent(slug)}`);

// Risk Radar — fail count per security category
export const getScannerRiskRadar = async (slug) =>
  apiClient.get(`/cspm/findings/risk-radar?companyKey=${encodeURIComponent(slug)}`);

// Category Detail — severity breakdown for a specific category
export const getScannerCategoryDetail = async (slug, category) =>
  apiClient.get(`/cspm/findings/category-detail?companyKey=${encodeURIComponent(slug)}&category=${encodeURIComponent(category)}`);

// Risk Pipeline — Sankey chart: provider → severity FAIL flow
export const getScannerRiskPipeline = async (slug) =>
  apiClient.get(`/cspm/findings/risk-pipeline?companyKey=${encodeURIComponent(slug)}`);

// Company-based timeline / services / attack-surface
export const getScannerTimeline = async (slug, days = 5) =>
  apiClient.get(`/cspm/findings/timeline?companyKey=${encodeURIComponent(slug)}&days=${days}`);

export const getScannerServices = async (slug) =>
  apiClient.get(`/cspm/findings/services?companyKey=${encodeURIComponent(slug)}`);

export const getScannerAttackSurface = async (slug) =>
  apiClient.get(`/cspm/findings/attack-surface?companyKey=${encodeURIComponent(slug)}`);

// Resources — cloud assets discovered by Prowler (last 7 days window)
export const getScannerResources = async (slug, page = 1, limit = 20, service, region, type) => {
  let url = `/cspm/resources?companyKey=${slug}&page=${page}&limit=${limit}`;
  if (service) url += `&service=${encodeURIComponent(service)}`;
  if (region) url += `&region=${encodeURIComponent(region)}`;
  if (type) url += `&type=${encodeURIComponent(type)}`;
  return apiClient.get(url);
};

// Tenant init — idempotent, creates the scanner organisation record if absent
export const initScannerTenant = async (slug) =>
  apiClient.post(`/cspm/tenants/init`, slug ? { companyKey: slug } : {});

